import React, { useEffect, useState, useCallback, useRef } from "react";
import { API_BASE_URL } from "./config";
import "./GlobalTechJobsBoard.css";
import GlobalJobsApplicationFlow from "./GlobalJobsApplicationFlow";
import GlobalJobsCandidateAccount from "./GlobalJobsCandidateAccount";

const PAGE_SIZE = 25;

const initialFilters = {
  search: "",
  country: "",
  job_type: "",
  work_mode: "",
  experience_min: "",
  experience_max: "",
  salary_min: "",
  salary_max: "",
  skills: "",
};



function countryFlag(code) {
  if (!code || !/^[A-Za-z]{2}$/.test(code)) return "<";
  return String.fromCodePoint(
    ...code.toUpperCase().split("").map(
      (character) => 127397 + character.charCodeAt(0)
    )
  );
}

function showValue(value, fallback = "Not specified") {
  return value === null || value === undefined || value === ""
    ? fallback
    : String(value);
}


// GTJ REFINEMENT V3
const gtjCountryCodeMap = {
  india:"in", usa:"us", "united states":"us",
  canada:"ca", "united kingdom":"gb", uk:"gb",
  germany:"de", france:"fr", australia:"au",
  japan:"jp", "south korea":"kr", singapore:"sg",
  brazil:"br", "united arab emirates":"ae", uae:"ae",
  netherlands:"nl", ireland:"ie", switzerland:"ch",
  sweden:"se", norway:"no", denmark:"dk",
  italy:"it", spain:"es", "new zealand":"nz",
  poland:"pl", portugal:"pt", belgium:"be",
  malaysia:"my", thailand:"th", indonesia:"id",
  vietnam:"vn", israel:"il", "saudi arabia":"sa",
  qatar:"qa", morocco:"ma", mexico:"mx",
  "south africa":"za", china:"cn"
};

function gtjFlagCode(job) {
  const code = String(job.country_code || "").trim().toLowerCase();
  if (/^[a-z]{2}$/.test(code)) return code;
  return gtjCountryCodeMap[
    String(job.country || "").trim().toLowerCase()
  ] || null;
}

// Display only. Full job IDs remain unchanged.
function gtjDisplayId(value) {
  const source = String(value || "");
  let hash = 2166136261;
  for (let i = 0; i < source.length; i++) {
    hash ^= source.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return String((hash >>> 0) % 10000).padStart(4, "0");
}


// GTJ SEARCH UX V4

const gtjCountryNames = new Intl.DisplayNames(["en"], {
  type: "region"
});

const gtjSelectableCountries = ["AW", "AF", "AO", "AI", "AX", "AL", "AD", "AE", "AR", "AM", "AS", "AQ", "TF", "AG", "AU", "AT", "AZ", "BI", "BE", "BJ", "BQ", "BF", "BD", "BG", "BH", "BS", "BA", "BL", "BY", "BZ", "BM", "BO", "BR", "BB", "BN", "BT", "BV", "BW", "CF", "CA", "CC", "CH", "CL", "CN", "CI", "CM", "CD", "CG", "CK", "CO", "KM", "CV", "CR", "CU", "CW", "CX", "KY", "CY", "CZ", "DE", "DJ", "DM", "DK", "DO", "DZ", "EC", "EG", "ER", "EH", "ES", "EE", "ET", "FI", "FJ", "FK", "FR", "FO", "FM", "GA", "GB", "GE", "GG", "GH", "GI", "GN", "GP", "GM", "GW", "GQ", "GR", "GD", "GL", "GT", "GF", "GU", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IM", "IN", "IO", "IE", "IR", "IQ", "IS", "IL", "IT", "JM", "JE", "JO", "JP", "KZ", "KE", "KG", "KH", "KI", "KN", "KR", "KW", "LA", "LB", "LR", "LY", "LC", "LI", "LK", "LS", "LT", "LU", "LV", "MO", "MF", "MA", "MC", "MD", "MG", "MV", "MX", "MH", "MK", "ML", "MT", "MM", "ME", "MN", "MP", "MZ", "MR", "MS", "MQ", "MU", "MW", "MY", "YT", "NA", "NC", "NE", "NF", "NG", "NI", "NU", "NL", "NO", "NP", "NR", "NZ", "OM", "PK", "PA", "PN", "PE", "PH", "PW", "PG", "PL", "PR", "KP", "PT", "PY", "PS", "PF", "QA", "RE", "RO", "RU", "RW", "SA", "SD", "SN", "SG", "GS", "SH", "SJ", "SB", "SL", "SV", "SM", "SO", "PM", "RS", "SS", "ST", "SR", "SK", "SI", "SE", "SZ", "SX", "SC", "SY", "TC", "TD", "TG", "TH", "TJ", "TK", "TM", "TL", "TO", "TT", "TN", "TR", "TV", "TW", "TZ", "UG", "UA", "UM", "UY", "US", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "ZA", "ZM", "ZW"]
  .map((code) => ({
    code,
    name: gtjCountryNames.of(code),
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

const gtjFilterLabels = {
  search: "Search",
  country: "Country",
  job_type: "Candidate",
  work_mode: "Work model",
  experience_min: "Min. experience",
  experience_max: "Max. experience",
  salary_min: "Min. salary",
  salary_max: "Max. salary",
  skills: "Technology",
};

function gtjFilterDisplay(key, value) {
  const labels = {
    fresher: "Fresher",
    experienced: "Experienced",
    internship: "Internship",
    both: "Both",
    remote: "Remote",
    hybrid: "Hybrid",
    semi_hybrid: "Semi-hybrid",
    onsite: "On-site",
  };

  const formatted = labels[value] || value;

  return gtjFilterLabels[key] + ": " +
    formatted +
    (key.startsWith("experience_") ? " years" : "");
}


function gtjCompanyInitials(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (!parts.length) return "CO";

  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return parts
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

function gtjSkillList(skills) {
  return (Array.isArray(skills)
    ? skills
    : String(skills || "").split(","))
    .map((skill) => String(skill).trim())
    .filter(Boolean);
}


// GTJ EXISTING MEMBER LOGIN V1
function GTJMemberLoginModal({ onClose, onLogin }) {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function authenticate(path, payload) {
    const response = await fetch(
      `${API_BASE_URL}/global-tech-jobs/${path}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload),
        cache: "no-store"
      }
    );

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const detail = data.detail;
      throw new Error(
        typeof detail === "string"
          ? detail
          : `Verification failed (${response.status}).`
      );
    }

    return data;
  }

  async function sendCode(event) {
    event.preventDefault();
    if (busy) return;

    const address = email.trim().toLowerCase();

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address)) {
      setError("Enter a valid email address.");
      return;
    }

    setBusy(true);
    setError("");

    try {
      await authenticate(
        "auth/request-otp",
        { email: address }
      );
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  async function verifyCode(event) {
    event.preventDefault();
    if (busy) return;

    if (!/^\d{6}$/.test(otp.trim())) {
      setError("Enter the six-digit verification code.");
      return;
    }

    setBusy(true);
    setError("");

    try {
      const result = await authenticate(
        "auth/verify-otp",
        {
          email: email.trim().toLowerCase(),
          otp: otp.trim()
        }
      );

      if (!result.access_token) {
        throw new Error("Login confirmation is missing.");
      }

      sessionStorage.setItem(
        "gtj_candidate_session_v1",
        result.access_token
      );

      window.dispatchEvent(new Event("gtj-wizard-login"));
      window.dispatchEvent(
        new Event("gtj-candidate-authenticated")
      );

      onLogin();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      className="gtj-member-login-backdrop"
      role="presentation"
      onMouseDown={event => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <section
        className="gtj-member-login-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="gtj-member-login-title"
      >
        <button
          type="button"
          className="gtj-member-login-close"
          aria-label="Close member login"
          onClick={onClose}
        >
          ×
        </button>

        <span className="gtj-member-login-eyebrow">
          SNEHACHIEVERS TECH AI
        </span>

        <h2 id="gtj-member-login-title">
          Member Login
        </h2>

        <p className="gtj-member-login-intro">
          {sent
            ? "Enter the verification code sent to your email."
            : "Verify your email to view your applications and explore jobs."}
        </p>

        <form onSubmit={sent ? verifyCode : sendCode}>
          <label htmlFor="gtj-member-login-email">
            Email address
          </label>

          <input
            id="gtj-member-login-email"
            type="email"
            value={email}
            onChange={event => {
              setEmail(event.target.value);
              setOtp("");
              setSent(false);
              setError("");
            }}
            placeholder="Enter your email address"
            autoComplete="email"
            disabled={busy}
            required
            autoFocus
          />

          {sent && (
            <>
              <label htmlFor="gtj-member-login-otp">
                Verification code
              </label>

              <input
                id="gtj-member-login-otp"
                type="text"
                inputMode="numeric"
                pattern="[0-9]{6}"
                maxLength={6}
                autoComplete="one-time-code"
                value={otp}
                onChange={event =>
                  setOtp(event.target.value.replace(/\D/g, ""))
                }
                placeholder="6-digit OTP"
                disabled={busy}
                required
              />
            </>
          )}

          {error && (
            <p className="gtj-member-login-error" role="alert">
              {error}
            </p>
          )}

          <button
            type="submit"
            className="gtj-member-login-submit"
            disabled={busy}
          >
            {busy
              ? "Please wait..."
              : sent
                ? "Verify & Login"
                : "Send Verification Code"}
          </button>

          {sent && (
            <button
              className="gtj-member-login-resend"
              type="button"
              onClick={sendCode}
              disabled={busy}
            >
              Resend OTP
            </button>
          )}
        </form>
      </section>
    </div>
  );
}

export default function GlobalTechJobsBoard() {
  // GTJ PREMIUM GRID LIST V2
  const [viewMode, setViewMode] = useState("grid");
  const [selectedJob, setSelectedJob] = useState(null);

  const [showMemberLogin, setShowMemberLogin] = useState(false);
  const [memberLoggedIn, setMemberLoggedIn] = useState(
    Boolean(sessionStorage.getItem("gtj_candidate_session_v1"))
  );

  useEffect(() => {
    const syncMemberLogin = () => {
      setMemberLoggedIn(
        Boolean(sessionStorage.getItem("gtj_candidate_session_v1"))
      );
    };

    const events = [
      "gtj-wizard-login",
      "gtj-candidate-authenticated",
      "gtj-candidate-logout",
      "focus"
    ];

    events.forEach(name =>
      window.addEventListener(name, syncMemberLogin)
    );

    const timer = window.setInterval(syncMemberLogin, 400);

    return () => {
      events.forEach(name =>
        window.removeEventListener(name, syncMemberLogin)
      );
      window.clearInterval(timer);
    };
  }, []);



  // GTJ ALREADY APPLIED JOB CARDS V2
  const [appliedJobIds, setAppliedJobIds] = useState(new Set());

  // GTJ LOGOUT APPLIED STATE FIX V2
  const appliedSessionRef = useRef(
    sessionStorage.getItem("gtj_candidate_session_v1")
  );
  const appliedRequestRef = useRef(0);


  const refreshAppliedJobs = useCallback(async () => {
    const token = sessionStorage.getItem(
      "gtj_candidate_session_v1"
    );

    const requestId = ++appliedRequestRef.current;
    appliedSessionRef.current = token;

    setAppliedJobIds(new Set());

    if (!token) return;

    try {
      const found = new Set();

      // Backend pagination is limited, so use pages of 20.
      for (let page = 1; page <= 500; page++) {
        const response = await fetch(
          `${API_BASE_URL}/global-tech-jobs/applications/me?page=${page}&page_size=20`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            },
            cache: "no-store"
          }
        );

        if (!response.ok) {
          throw new Error("Unable to load application history.");
        }

        const data = await response.json();

        const items = Array.isArray(data.items)
          ? data.items
          : Array.isArray(data.applications)
            ? data.applications
            : [];

        items.forEach(item => {
          if (item.job_id) {
            found.add(String(item.job_id));
          }
        });

        if (items.length < 20) break;
      }

      if (
        requestId === appliedRequestRef.current &&
        sessionStorage.getItem("gtj_candidate_session_v1") === token
      ) {
        setAppliedJobIds(found);
      }

    } catch (error) {
      console.warn("Application status refresh:", error.message);
    }
  }, []);

  useEffect(() => {
    refreshAppliedJobs();

    const events = [
      "gtj-applications-changed",
      "gtj-wizard-login",
      "gtj-candidate-authenticated"
    ];

    events.forEach(name =>
      window.addEventListener(name, refreshAppliedJobs)
    );

    return () => events.forEach(name =>
      window.removeEventListener(name, refreshAppliedJobs)
    );
  }, [refreshAppliedJobs]);


  useEffect(() => {
    const syncCandidate = () => {
      const token = sessionStorage.getItem(
        "gtj_candidate_session_v1"
      );

      if (token !== appliedSessionRef.current) {
        appliedSessionRef.current = token;
        appliedRequestRef.current += 1;
        setAppliedJobIds(new Set());

        if (token) refreshAppliedJobs();
      }
    };

    const timer = window.setInterval(syncCandidate, 400);

    window.addEventListener("focus", syncCandidate);
    window.addEventListener("pageshow", syncCandidate);
    window.addEventListener("gtj-candidate-logout", syncCandidate);

    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", syncCandidate);
      window.removeEventListener("pageshow", syncCandidate);
      window.removeEventListener("gtj-candidate-logout", syncCandidate);
    };
  }, [refreshAppliedJobs]);

  const hasAppliedToJob = (job) =>
    Boolean(sessionStorage.getItem("gtj_candidate_session_v1")) &&
    appliedSessionRef.current ===
      sessionStorage.getItem("gtj_candidate_session_v1") &&
    appliedJobIds.has(String(job.job_id || job.id));

  const openJobApplication = (job) => {
    if (hasAppliedToJob(job)) return;
    setSelectedJob(job);
  };

  // GTJ APPLY FIRST LOGIN V23
  // GTJ BROWSER APPLY JOURNEY V3
  const applicationsEnabled =
    process.env.REACT_APP_GTJ_APPLICATIONS_ENABLED === "true";
  const [draft, setDraft] = useState(initialFilters);
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [filters, setFilters] = useState(initialFilters);
  const [page, setPage] = useState(1);
  const [jobs, setJobs] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [apiReady, setApiReady] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const controller = new AbortController();

    const loadJobs = async () => {
      setLoading(true);
      setError("");

      try {
        const params = new URLSearchParams({
          page: String(page),
          page_size: String(PAGE_SIZE),
        });

        for (const [key, value] of Object.entries(filters)) {
          if (String(value).trim()) {
            params.set(key, String(value).trim());
          }
        }

        const response = await fetch(
          `${API_BASE_URL}/global-tech-jobs?${params}`,
          { signal: controller.signal }
        );

        if (!response.ok) {
          throw new Error("Jobs API is not available yet.");
        }

        const data = await response.json();

        if (
          !data ||
          !Array.isArray(data.items) ||
          !Number.isFinite(Number(data.total))
        ) {
          throw new Error("Unexpected jobs API response.");
        }

        if (!controller.signal.aborted) {
          setJobs(data.items.slice(0, PAGE_SIZE));
          setTotal(Number(data.total));
          setApiReady(true);
        }
      } catch (err) {
        if (controller.signal.aborted) return;
        setJobs([]);
        setTotal(0);
        setApiReady(false);
        setError(err.message || "Unable to load opportunities.");
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    loadJobs();

    return () => controller.abort();
  }, [filters, page]);

  const update = (name, value) => {
    setDraft((previous) => ({ ...previous, [name]: value }));
  };

  const searchJobs = (event) => {
    event.preventDefault();
    setPage(1);
    setFilters({ ...draft });

    // GTJ AUTO COLLAPSE FILTERS V1
    // Close advanced filters after applying search criteria.
    setShowMoreFilters(false);
  };

  const resetFilters = () => {
    setDraft(initialFilters);
    setFilters(initialFilters);
    setPage(1);
  };

  const removeAppliedFilter = (name) => {
    setDraft((previous) => ({
      ...previous,
      [name]: "",
    }));
    setFilters((previous) => ({
      ...previous,
      [name]: "",
    }));
    setPage(1);
  };


  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  return (
    <section className="gtj-board" id="tech-jobs">
      <div className="gtj-container">
        {/* GTJ CLEAN JOB BOARD V1 */}
        {/* GTJ CANDIDATE ACCOUNT RESTORE V1 */}
        <GlobalJobsCandidateAccount />


        {showMemberLogin && (
          <GTJMemberLoginModal
            onClose={() => setShowMemberLogin(false)}
            onLogin={() => {
              setMemberLoggedIn(true);
              setShowMemberLogin(false);
            }}
          />
        )}

        {selectedJob && (
          <GlobalJobsApplicationFlow
            job={selectedJob}
            onClose={() => setSelectedJob(null)}
          />
        )}

        <div className="gtj-listing-header">
          <div>
            <span className="gtj-eyebrow">DISCOVER OPPORTUNITIES</span>
            <h2>Apply for Jobs</h2>

            <div className="gtj-header-salary">
              <strong>
                ₹5 LPA · ₹10 LPA · ₹25 LPA · ₹40 LPA ·
                ₹50 LPA · ₹1 Crore+
              </strong>
              <small>
                Explore worldwide opportunities. Salary figures are
                illustrative and depend on the role, employer and experience.
              </small>
            </div>

          </div>

          {!memberLoggedIn && (
            <button
              type="button"
              className="gtj-existing-member-login"
              onClick={() => setShowMemberLogin(true)}
            >
              Member Login
            </button>
          )}

          <span className="gtj-count">
            {apiReady ? `${total} opportunities` : "Jobs opening soon"}
          </span>
        </div>


        {/* GTJ COMPACT FILTERS V1 */}
        <form className="gtj-filters gtj-filters-compact" onSubmit={searchJobs}>
          <div className="gtj-search-primary">
            <label className="gtj-search-keywords">
              <span>Search opportunities</span>
              <input
                type="search"
                value={draft.search}
                onChange={(e) => update("search", e.target.value)}
                placeholder="Job title, company, technology or job ID"
              />
            </label>

            <label>
              <span>Country</span>
              <input
                type="search"
                list="gtj-country-suggestions"
                value={draft.country}
                onChange={(e) => update("country", e.target.value)}
                placeholder="Search or select country"
                autoComplete="off"
              />
              <datalist id="gtj-country-suggestions">
                {gtjSelectableCountries.map((country) => (
                  <option
                    key={country.code}
                    value={country.name}
                    label={country.code}
                  />
                ))}
              </datalist>
            </label>

            <label>
              <span>Work model</span>
              <select
                value={draft.work_mode}
                onChange={(e) => update("work_mode", e.target.value)}
              >
                <option value="">All work models</option>
                <option value="remote">Remote</option>
                <option value="hybrid">Hybrid</option>
                <option value="semi_hybrid">Semi-hybrid</option>
                <option value="onsite">On-site</option>
              </select>
            </label>

            <button className="gtj-search-submit" type="submit">
              Search Jobs
            </button>
          </div>

          <div className="gtj-search-toolbar">
            <button
              type="button"
              className="gtj-more-toggle"
              onClick={() => setShowMoreFilters((previous) => !previous)}
              aria-expanded={showMoreFilters}
              aria-controls="gtj-advanced-filters"
            >
              <span aria-hidden="true">&#9881;</span>
              {showMoreFilters ? "Fewer Filters" : "More Filters"}
              <span aria-hidden="true">
                {showMoreFilters ? " \u25B2" : " \u25BC"}
              </span>
            </button>

            <span className="gtj-filter-summary">
              {Object.values(filters).filter(
                (value) => String(value).trim() !== ""
              ).length} active filters
            </span>

            <button
              type="button"
              className="gtj-clear-btn"
              onClick={resetFilters}
            >
              Clear Filters
            </button>
          </div>


          {/* GTJ ACTIVE FILTER CHIPS V1 */}
          {Object.entries(filters).some(
            ([, value]) => String(value).trim() !== ""
          ) && (
            <div
              className="gtj-active-filter-row"
              aria-label="Applied job search filters"
            >
              <span className="gtj-active-filter-title">
                Active filters:
              </span>

              {Object.entries(filters)
                .filter(([, value]) => String(value).trim() !== "")
                .map(([name, value]) => (
                  <button
                    key={name}
                    type="button"
                    className="gtj-active-filter-chip"
                    onClick={() => removeAppliedFilter(name)}
                    title={`Remove ${gtjFilterLabels[name]} filter`}
                    aria-label={`Remove ${gtjFilterLabels[name]} filter`}
                  >
                    <span>{gtjFilterDisplay(name, value)}</span>
                    <span aria-hidden="true">×</span>
                  </button>
                ))}
            </div>
          )}

          {showMoreFilters && (
            <div
              id="gtj-advanced-filters"
              className="gtj-advanced-filters"
            >
              <div className="gtj-advanced-heading">
                <strong>Refine your search</strong>
                <span>Choose only the criteria you need</span>
              </div>

              <div className="gtj-advanced-grid">
                <label>
                  Candidate type
                  <select
                    value={draft.job_type}
                    onChange={(e) => update("job_type", e.target.value)}
                  >
                    <option value="">All candidates</option>
                    <option value="fresher">Fresher</option>
                    <option value="experienced">Experienced</option>
                    {/* GTJ INTERNSHIP CANDIDATE TYPE V1 */}
                    <option value="internship">Internship</option>
                    <option value="both">Both</option>
                  </select>
                </label>

                <label>
                  Minimum experience (years)
                  <input
                    type="number"
                    min="0"
                    value={draft.experience_min}
                    onChange={(e) => update("experience_min", e.target.value)}
                    placeholder="Any"
                  />
                </label>

                <label>
                  Maximum experience (years)
                  <input
                    type="number"
                    min="0"
                    value={draft.experience_max}
                    onChange={(e) => update("experience_max", e.target.value)}
                    placeholder="Any"
                  />
                </label>

                <label>
                  Minimum salary
                  <input
                    type="number"
                    min="0"
                    value={draft.salary_min}
                    onChange={(e) => update("salary_min", e.target.value)}
                    placeholder="Any"
                  />
                </label>

                <label>
                  Maximum salary
                  <input
                    type="number"
                    min="0"
                    value={draft.salary_max}
                    onChange={(e) => update("salary_max", e.target.value)}
                    placeholder="Any"
                  />
                </label>

                <label>
                  Technology / skills
                  <input
                    value={draft.skills}
                    onChange={(e) => update("skills", e.target.value)}
                    placeholder="Python, React.js, AI..."
                  />
                </label>
              </div>

              <p className="gtj-filter-note">
                Salary filtering follows the currency and pay period
                supported by each job listing.
              </p>

              <div className="gtj-advanced-actions">
                <button type="submit" className="gtj-search-submit">
                  Apply Filters
                </button>
                <button type="button" onClick={resetFilters}>
                  Reset All
                </button>
              </div>
            </div>
          )}
        </form>

        
        {/* GTJ PREMIUM GRID LIST V2 */}
        <div className="gtj-view-toolbar">
          <div className="gtj-view-title">
            <h3>Latest Opportunities</h3>
            <span>{total} matching opportunities</span>
          </div>

          <div
            className="gtj-view-switch"
            role="group"
            aria-label="Job listing view"
          >
            <button
              type="button"
              className={viewMode === "grid" ? "active" : ""}
              onClick={() => setViewMode("grid")}
              aria-pressed={viewMode === "grid"}
            >
              <span aria-hidden="true">▦</span> Grid
            </button>

            <button
              type="button"
              className={viewMode === "list" ? "active" : ""}
              onClick={() => setViewMode("list")}
              aria-pressed={viewMode === "list"}
            >
              <span aria-hidden="true">☷</span> List
            </button>
          </div>
        </div>

<div className="gtj-results" aria-live="polite">
          {loading ? (
            <div className="gtj-empty">Loading opportunities...</div>
          ) : !apiReady ? (
            <div className="gtj-empty">
              <h3>Our new job opportunities portal is being prepared.</h3>
              <p>
                Verified opportunities will appear here after the
                admin-managed jobs service is connected.
              </p>
              <small>{error}</small>
            </div>
          ) : jobs.length === 0 ? (
            <div className="gtj-empty">
              <h3>No matching opportunities right now.</h3>
              <p>Try changing your filters or checking again later.</p>
            </div>
          ) : (
            <div className={
              viewMode === "grid"
                ? "gtj-jobs gtj-premium-grid"
                : "gtj-jobs gtj-premium-list"
            }>
              {jobs.map((job) => (
                <article
                  className="gtj-job-card"
                  key={job.job_id || job.id}
                >
                  
                  {viewMode === "grid" && (
                    <div className="gtj-premium-card">

                      <div className="gtj-premium-company">
                        <div className="gtj-premium-avatar">
                          {gtjCompanyInitials(job.company)}
                        </div>

                        <div className="gtj-premium-employer">
                          <strong>{showValue(job.company)}</strong>

                          <span className="gtj-premium-country">
                            {gtjFlagCode(job) ? (
                              <img
                                src={`https://flagcdn.com/w40/${gtjFlagCode(job)}.png`}
                                alt=""
                                width="27"
                                height="19"
                                loading="lazy"
                              />
                            ) : (
                              <span aria-hidden="true">🌐</span>
                            )}

                            {showValue(job.country)}
                          </span>
                        </div>
                      </div>

                      <div className="gtj-premium-position">
                        <h3>{showValue(job.title)}</h3>
                        <span
                          title={`Full ID: ${showValue(job.job_id || job.id)}`}
                        >
                          #{gtjDisplayId(job.job_id || job.id)}
                        </span>
                      </div>

                      <div className="gtj-premium-details">
                        <span>
                          <span aria-hidden="true">▣</span>
                          {showValue(job.work_mode).replace(/_/g, "-")}
                        </span>

                        <span>
                          <span aria-hidden="true">▤</span>
                          {showValue(job.experience_range)}
                        </span>

                        <span>
                          <span aria-hidden="true">♙</span>
                          {showValue(job.job_type)}
                        </span>
                      </div>

                      <div className="gtj-premium-salary">
                        <small>
                          {job.job_type === "internship"
                            ? "Internship compensation"
                            : "Salary"}
                        </small>
                        <strong>{showValue(job.salary_display)}</strong>
                      </div>

                      <div className="gtj-premium-skills">
                        <span className="gtj-premium-label">
                          Technologies Required
                        </span>

                        <div className="gtj-premium-skill-list">
                          {gtjSkillList(job.skills).map((skill, index) => (
                            <span
                              className="gtj-premium-skill"
                              key={`${skill}-${index}`}
                            >
                              {skill}
                            </span>
                          ))}
                        </div>
                      </div>

                      <button
                        className={
                          "gtj-premium-apply" +
                          (hasAppliedToJob(job) ? " gtj-already-applied" : "")
                        }
                        disabled={hasAppliedToJob(job)}
                        type="button"
                        onClick={() => openJobApplication(job)}
                      >
                        {hasAppliedToJob(job) ? "✓ Already Applied" : "Apply Now"}
                      </button>

                    </div>
                  )}

                  <div className="gtj-job-row">

                    
<div className="gtj-row-cell gtj-row-country">
  <span className="gtj-row-label">Country</span>
  <div className="gtj-flag-country">
    {gtjFlagCode(job) ? (
      <img
        src={`https://flagcdn.com/w40/${gtjFlagCode(job)}.png`}
        alt=""
        loading="lazy"
        width="30"
        height="20"
      />
    ) : (
      <span aria-hidden="true">🌐</span>
    )}
    <strong>{showValue(job.country)}</strong>
  </div>
</div>

                    
<div className="gtj-row-cell gtj-row-id">
  <span className="gtj-row-label">Job ID</span>
  <strong
    className="gtj-display-id"
    title={`Full ID: ${showValue(job.job_id || job.id)}`}
  >
    #{gtjDisplayId(job.job_id || job.id)}
  </strong>
</div>

                    <div className="gtj-row-cell gtj-row-position">
                      <span className="gtj-row-label">Job Position</span>
                      <strong>{showValue(job.title)}</strong>
                      <small>{showValue(job.company)}</small>
                    </div>

                    <div className="gtj-row-cell">
                      <span className="gtj-row-label">Candidate</span>
                      <span>{showValue(job.job_type)}</span>
                    </div>

                    <div className="gtj-row-cell">
                      <span className="gtj-row-label">Experience</span>
                      <span>{showValue(job.experience_range)}</span>
                    </div>

                    <div className="gtj-row-cell">
                      <span className="gtj-row-label">Work Model</span>
                      <span>{showValue(job.work_mode)}</span>
                    </div>

                    

                    <div className="gtj-row-cell gtj-row-salary">
                      <span className="gtj-row-label">Salary</span>
                      <strong>{showValue(job.salary_display)}</strong>
                    </div>

                    <div className="gtj-row-cell gtj-row-apply">
                      <span className="gtj-row-label">Apply</span>
                      <button
                        className={
                          hasAppliedToJob(job)
                            ? "gtj-already-applied"
                            : ""
                        }
                        disabled={hasAppliedToJob(job)}
                        type="button"
                        title={
                          applicationsEnabled
                            ? "Apply for this job"
                            : "Applications opening soon"
                        }
                        onClick={() => openJobApplication(job)}
                      >
                        {hasAppliedToJob(job) ? "✓ Already Applied" : "Apply Now"}
                      </button>
                    </div>

                  </div>

<div className="gtj-technologies-row">
  <span className="gtj-row-label">Technologies Required</span>
  <span className="gtj-technologies-value">
    {Array.isArray(job.skills)
      ? job.skills.join(", ")
      : showValue(job.skills)}
  </span>
</div>
</article>
              ))}
            </div>
          )}
        </div>

        {apiReady && !loading && totalPages > 1 && (
          <div className="gtj-pagination">
            <button
              disabled={page <= 1}
              onClick={() => setPage((p) => p - 1)}
              type="button"
            >
              Previous
            </button>
            <span>Page {page} of {totalPages}</span>
            <button
              disabled={page >= totalPages}
              onClick={() => setPage((p) => p + 1)}
              type="button"
            >
              Next
            </button>
          </div>
        )}

        <div className="gtj-membership-preview">
          <div>
            <span>COMING NEXT • CANDIDATE ACCESS</span>
            <h3>One Annual Membership. Multiple Opportunities.</h3>
            <p>
              ₹49 annual access will support AI-assisted resume
              screening and job matching. Membership will run
              through 31 December of the payment year.
              Payment will not guarantee an interview or job.
            </p>
          </div>
          <strong>₹49 / year</strong>
        </div>
      </div>
    </section>
  );
}
